import React from 'react';
import { Checkbox, Collapse } from 'antd';

const { Panel } = Collapse;

// Условия платежа/аннуляции/автоплатежа с чекбоксами согласия.
// cond1/cond2/cond3 - состояние чекбоксов, autopay - показывать ли условия автоплатежа
const PaymentTerms = ({ company, autopay, cond1, cond2, cond3, setCond1, setCond2, setCond3 }) => {
    const offerAutopay = company && company.offerAutopay ? company.offerAutopay : process.env.REACT_APP_OFFER_AUTOPAY;
    const offerPayment = company && company.offerPayment ? company.offerPayment : process.env.REACT_APP_OFFER_PAYMENT;
    const divExtraInfo = <a href={offerPayment} target='_blank' rel='noreferrer'>условиями</a>;

    return (
        <>
            <Collapse size='small' accordion ghost expandIconPosition='end'>
                <Panel header='Условия платежа' key='1'>
                    Соглашаясь с {divExtraInfo} платежа, вы соглашаетесь с составом и стоимостью заказа, а также с суммой комиссии,
                    если она указана в заказе. Пожалуйста, внимательно ознакомьтесь с наименованием состава заказа,
                    стоимостью заказа и описанием предоставления заказа.
                </Panel>
                <Panel header='Условия аннуляции заказа' key='2'>
                    Для аннуляции оплаченного заказа вы можете обратиться с Заявлением на возврат суммы оплаты на вашу банковскую карту к Поставщику услуг, указанному в чеке, или на e-mail Компании Проффит: inbox@fitnessoft.ru Аннуляция заказа и возврат оплаты возможны до начала использования заказа. В случае  аннулирования заказа Поставщик услуг имеет право взимать с клиента сервисный сбор в размере фактически понесенных расходов. Сервисный сбор включается в стоимость заказа. Размер сервисного сбора не может превышать 5% от оплаченной клиентом суммы. При аннуляции заказа до момента использования заказа денежные средства будут возвращены на банковскую карту,  которой была произведена оплата услуги в течение 10 рабочих дней с момента получения  Поставщиком услуг Зявления на возврат. В случае аннуляции заказа после начала использования заказа для возврата денежных средств вам необходимо обратиться непосредственно к Поставщику услуг для расчёта и возврата  остатка стоимости заказа.
                </Panel>
                {autopay ? (
                    <Panel header='Условия сервиса “Автоплатеж”' key='3'>
                        Условия пользования сервисом «Автоплатеж» в соответствии со ст.435 ГК РФ являются офертой, адресованной Пользователю. Пользователь, как держатель банковской карты,
                        производя оплату соглашается с <a href={offerAutopay} target='_blank' rel='noreferrer'>Условиями</a>
                    </Panel>
                ) : null}
            </Collapse>
            <div className='payment-terms-checks'>
                <Checkbox onChange={(e) => setCond1(e.target.checked)} checked={cond1}>
                    Я согласен с условиями платежа
                </Checkbox>
                <Checkbox onChange={(e) => setCond2(e.target.checked)} checked={cond2}>
                    Я согласен с условиями аннуляции заявки
                </Checkbox>
                {autopay ? (
                    <Checkbox onChange={(e) => setCond3(e.target.checked)} checked={cond3}>
                        Я согласен с сохранением данных карты и условиями сервиса "Автоплатеж"
                    </Checkbox>
                ) : null}
            </div>
        </>
    );
};

export default PaymentTerms;
